import {
  ChangeDetectionStrategy,
  Component
} from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "src/app/modules/auth/services/auth.service";
import { CamerallaAuthService } from "src/app/shared/services/authentication-services/cameralla-auth.service";

@Component({
  selector: "app-main-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
  localUserId;
  constructor(
    private camerallaAuthService: CamerallaAuthService,
    private authService: AuthService,
    private router: Router
  ) {}
  ngOnInit() {
    this.localUserId = +this.camerallaAuthService.getLocalUserInfo()["id"];
  }

    logout() {
      this.camerallaAuthService.logout().then(() => {
        this.router.navigate(["/"]);
      });
    }
}
